module.exports = __webpack_public_path__ + "static/img/wechat-icon.ac4366c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/outer/wechat-icon.png
// module id = uGce
// module chunks = 226